var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconObTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ob-templates",
    transform: "translate(-308 -969)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(308 969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847",
    transform: "translate(319.123 988.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3844",
    "data-name": "Group 3844",
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 11.713, 27.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1532",
    "data-name": "Rectangle 1532",
    width: 62,
    height: 25.095,
    rx: 8,
    transform: "translate(2.214 2.214)",
    fill: "#88c4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1531",
    "data-name": "Rectangle 1531",
    width: 62,
    height: 25.095,
    rx: 8,
    fill: "#f1f6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2964",
    "data-name": "Group 2964",
    transform: "translate(7.395 9.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2963",
    "data-name": "Group 2963",
    transform: "translate(0 0.152)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 3.381,
    cy: 3.381,
    r: 3.381,
    fill: "#2092ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1533",
    "data-name": "Rectangle 1533",
    width: 39,
    height: 2,
    rx: 1,
    transform: "translate(10.713)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1534",
    "data-name": "Rectangle 1534",
    width: 24,
    height: 2,
    rx: 1,
    transform: "translate(10.713 5.112)",
    fill: "#d1d1d1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3843",
    "data-name": "Group 3843",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 0, 5.597)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1532-2",
    "data-name": "Rectangle 1532",
    width: 62,
    height: 25.095,
    rx: 8,
    transform: "translate(2.214 2.214)",
    fill: "#18ce99"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1531-2",
    "data-name": "Rectangle 1531",
    width: 62,
    height: 25.095,
    rx: 8,
    transform: "translate(0)",
    fill: "#e5fff7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2964-2",
    "data-name": "Group 2964",
    transform: "translate(6.249 8.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3461",
    "data-name": "Group 3461",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3477",
    "data-name": "Group 3477",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M3.888,8.154a.945.945,0,0,1-.668-.277L.276,4.934A.945.945,0,0,1,1.612,3.6L3.888,5.874l5.6-5.6a.945.945,0,1,1,1.336,1.336h0L4.558,7.877A.945.945,0,0,1,3.888,8.154Z",
    fill: "#18ce99"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1535",
    "data-name": "Rectangle 1535",
    width: 22,
    height: 2,
    rx: 1,
    transform: "translate(15.191 5.561)",
    fill: "#18ce99"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1536",
    "data-name": "Rectangle 1536",
    width: 35,
    height: 2,
    rx: 1,
    transform: "translate(15.191 0.561)",
    fill: "#18ce99"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconObTemplates);
export default __webpack_public_path__ + "static/media/icon-ob-templates.14342e006a7555754466867dee129b63.svg";
export { ForwardRef as ReactComponent };